import NotAuthorised from '../pages/NotAuthorised';
import { DecryptData } from './encryptDecrypt';

const RouteAuthService = ({ route, component }) => {
    let notAllowedRoutes = ['datasets','usertype','role','dataSource','userManagement','calculatedFields','settings','alertList','manageDataset']
    let menusAllowed = localStorage.getItem('menusAllowed') ? JSON.parse(DecryptData(localStorage.getItem('menusAllowed'))) : []
    let role = DecryptData(localStorage.getItem('role'))

    if (role === 'superadmin') {
        return component
    }
    else if(notAllowedRoutes.indexOf(route) > -1){
        return <NotAuthorised isOpen={true} />
    }
    else if (menusAllowed.find(obj => obj.menuId === route)) {
        return component
    }
    else {
        return <NotAuthorised isOpen={true} />
    }
}

export default RouteAuthService